export const Loca_SEARCH_LOCATION = 'SEARCH_LOCATION'
export const Loca_SET_LOCATIONS = 'SET_LOCATIONS'
export const Loca_SET_NEARBY_LOCATIONS = 'SET_NEARBY_LOCATIONS'
export const Loca_SET_SEARCH_LOCATIONS = 'SET_SEARCH_LOCATIONS'
export const Loca_SET_DOWNLOADING_LOCATIONS = 'SET_DOWNLOADING_LOCATIONS'
export const Loca_SET_TIMELINE = 'SET_TIMELINE'
export const Loca_GET_TIMELINE = 'GET_TIMELINE'
export const Loca_SELECT_LOCATION = 'SELECT_LOCATION'
export const Loca_SELECT_EVENT = 'SELECT_EVENT'
export const Loca_SET_ADDRESS = 'SET_ADDRESS'
export const Loca_SET_ADDRESS_FIELD = 'SET_ADDRESS_FIELD'
export const Loca_SET_REPORT_EVENT = 'SET_REPORT_EVENT'
export const Loca_SET_REPORT_FOCUSLIST = 'SET_REPORT_FOCUSLIST'
export const Loca_SET_DIALOG_OPEN = 'SET_DIALOG_OPEN'
export const Loca_SET_DIALOG_TYPE = 'SET_DIALOG_TYPE'
export const Loca_SET_DIALOG_EVENTS = 'SET_DIALOG_EVENTS'
export const Loca_SET_DIALOG_CAMPAIGNS = 'SET_DIALOG_CAMPAIGNS'
